import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const kolide = defineConnector({
  identifier: "kolide",
  name: "Kolide",
  tagLine: "Device trust and security",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: () => "https://api\\.kolide\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "Bearer",
      },
      {
        name: "X-Kolide-Api-Version",
        value: "2023-05-26",
      },
    ]),
  steps: [
    {
      title: "Create a Kolide API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Kolide, open **Settings > Developers > API Keys** and create a new key. Kolide uses token-based authentication with the `Authorization` header.",
        },
      ],
    },
    {
      title: "Enter your Kolide API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.kolide.com/audit_logs",
  },
});
